import React from 'react';

const LoadingComponent = (props:any) => (
    <div className="loading" data-size={props.size}>로딩중입니다.....</div>
);

export default LoadingComponent;